import * as types from 'store/modules/hrms17e/mutation-types'
import hrms17e from 'api/hrms17e'
import swal from 'sweetalert'
import hrms17eLabels from 'assets/labels/hrms17e'
import { hrms17eMaxRowspan, hrms17eColumns } from 'assets/columns/hrms17e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detail1Disp: false,
    detail2Disp: false,
    labels: hrms17eLabels,
    maxRowspan: hrms17eMaxRowspan,
    columns: hrms17eColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail1: {
      total: 0,
      rows: []
    },
    detail2: {
      detail: {},
      tab1: {
        total: 0,
        rows: []
      },
      tab2: {
        total: 0,
        rows: []
      }
    },
    dropdowns: {
      mtrunit: {
        en: {},
        th: {}
      }
    },
    resultImport: {
      total: 0,
      rows: []
    },
    codempidQuery: {},
    searchParamsIndex: {},
    indexSelected: {},
    inlineDetail2Tab1: {},
    inlineDetail2Tab2: {},
    detail1Selected: {},
    detail2Tab1Selected: {}
  },
  getters: {
    [types.GET_HRMS17E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS17E_DETAIL1_DISP] (state) {
      return state.detail1Disp
    },
    [types.GET_HRMS17E_DETAIL2_DISP] (state) {
      return state.detail2Disp
    },
    [types.GET_HRMS17E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS17E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS17E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS17E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS17E_SEARCH_PARAMS_INDEX] (state) {
      return state.searchParamsIndex
    },
    [types.GET_HRMS17E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS17E_DETAIL1_SELECTED] (state) {
      return state.detail1Selected
    },
    [types.GET_HRMS17E_INLINE_DETAIL2_TAB1] (state) {
      return state.inlineDetail2Tab1
    },
    [types.GET_HRMS17E_INLINE_DETAIL2_TAB2] (state) {
      return state.inlineDetail2Tab2
    },
    [types.GET_HRMS17E_DETAIL] (state) {
      return state.detail1
    },
    [types.GET_HRMS17E_DETAIL2] (state) {
      return state.detail2
    },
    [types.GET_HRMS17E_CODEMPID] (state) {
      return state.codempidQuery
    },
    [types.GET_HRMS17E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRMS17E_IMPORT] (state) {
      return state.resultImport
    }
  },
  mutations: {
    [types.SET_HRMS17E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS17E_DETAIL1_DISP] (state, detail1Disp) {
      state.detail1Disp = detail1Disp
    },
    [types.SET_HRMS17E_DETAIL2_DISP] (state, detail2Disp) {
      state.detail2Disp = detail2Disp
    },
    [types.SET_HRMS17E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detail1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail1Table, labels[keyLang])
        state.columns[keyLang].detail2Tab1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail2Tab1Table, labels[keyLang])
        state.columns[keyLang].detail2Tab2Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail2Tab2Table, labels[keyLang])
      }
    },
    [types.SET_HRMS17E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS17E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS17E_SEARCH_PARAMS_INDEX] (state, searchParamsIndex) {
      state.searchParamsIndex = searchParamsIndex
    },
    [types.SET_HRMS17E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS17E_DETAIL1_SELECTED] (state, detail1Selected) {
      state.detail1Selected = detail1Selected
    },
    [types.SET_HRMS17E_INLINE_DETAIL2_TAB1] (state, inlineDetail2Tab1) {
      state.inlineDetail2Tab1 = inlineDetail2Tab1
    },
    [types.SET_HRMS17E_INLINE_DETAIL2_TAB2] (state, inlineDetail2Tab2) {
      state.inlineDetail2Tab2 = inlineDetail2Tab2
    },
    [types.SET_HRMS17E_DETAIL] (state, data) {
      state.detail1 = data
    },
    [types.SET_HRMS17E_DETAIL2] (state, data) {
      state.detail2 = data
    },
    [types.SET_HRMS17E_CODEMPID] (state, data) {
      state.codempidQuery = data
    },
    [types.SET_HRMS17E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRMS17E_IMPORT] (state, data) {
      state.resultImport = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS17E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detail1Disp = false
      let detail2Disp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail1':
          detail1Disp = true
          break
        case 'detail2':
          detail2Disp = true
      }
      commit(types.SET_HRMS17E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS17E_DETAIL1_DISP, detail1Disp)
      commit(types.SET_HRMS17E_DETAIL2_DISP, detail2Disp)
    },
    [types.RECEIVED_HRMS17E_COLUMNS_LABELS] ({ commit }) {
      hrms17e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_COLUMNS, data.labels)
          commit(types.SET_HRMS17E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS17E_DROPDOWNS] ({ commit }) {
      hrms17e.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS17E_INDEX] ({ commit }, searchParams) {
      hrms17e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_INDEX, data)
          commit(types.SET_HRMS17E_SEARCH_PARAMS_INDEX, searchParams)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS17E_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS17E_CREATE] ({ commit }, searchParams) {
      hrms17e.getCreate(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS17E_DETAIL] ({ commit }, editParams) {
      hrms17e.getDetail(editParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS17E_CODEMPID] ({ commit }, codempid) {
      if (codempid !== '') {
        hrms17e.getCodempidQuery(codempid)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_HRMS17E_CODEMPID, data)
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      } else {
        commit(types.SET_HRMS17E_CODEMPID, {})
      }
    },
    [types.RECEIVED_HRMS17E_DETAIL2_CREATE] ({ commit }, addParams) {
      hrms17e.getDetail2Create(addParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_DETAIL2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS17E_DETAIL2] ({ commit }, editParams) {
      hrms17e.getDetail2(editParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS17E_DETAIL2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS17E_DELETE] ({ commit, dispatch }, { searchIndex, dataRowsHasFlg, indexSelected }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms17e.postDelete({ searchIndex, dataRowsHasFlg, indexSelected })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS17E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS17E_DETAIL1_TABLE_DELETE] ({ commit, dispatch }, { searchIndex, indexSelected, dataRowsHasFlg }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms17e.postDetail1TableDelete({ searchIndex, indexSelected, dataRowsHasFlg })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              let searchDetailParams = {
                p_dteyreap: searchIndex.year,
                p_numtime: searchIndex.numtime,
                p_codempid_query: indexSelected.codempid
              }
              dispatch(types.RECEIVED_HRMS17E_DETAIL, searchDetailParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS17E_DETAIL2_SAVE] ({ commit, dispatch }, { dataHeader, searchIndex, detail2, detail1Selected, indexSelected }) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hrms17e.postDetail2Save({ dataHeader, searchIndex, detail2, detail1Selected })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (!((searchIndex.codcomp === '' && searchIndex.codempid3 === '') || (searchIndex.year === '') || (searchIndex.numtime === '') || (searchIndex.codempid2 === '') || (searchIndex.dteappr === ''))) {
            dispatch(types.RECEIVED_HRMS17E_INDEX, searchIndex)
          }
          let searchDetailParams = {
            p_dteyreap: searchIndex.year,
            p_numtime: searchIndex.numtime,
            p_codempid_query: dataHeader.codempid
          }
          dispatch(types.RECEIVED_HRMS17E_DETAIL, searchDetailParams)
          let searchDetail2Params = {
            p_codempid_query: dataHeader.codempid,
            p_dteyreap: searchIndex.year,
            p_numtime: searchIndex.numtime,
            p_kpino: detail2.kpino
          }
          dispatch(types.RECEIVED_HRMS17E_DETAIL2, searchDetail2Params)
          swal({
            title: '', text: data.response, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS17E_IMPORT] ({ commit, dispatch }, {searchIndex, dataHeader, dataRowsHasFlg}) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hrms17e.postImportKpi({searchIndex, dataHeader, dataRowsHasFlg})
        .then((response) => {
          const data = JSON.parse(response.request.response)
          swal({
            title: '', text: data.rows[0].desc_coderror, html: true, type: 'success'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS17E_IMPORT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms17e/index.js